import { useSelector } from 'react-redux'
import {
  ToggleButtonGroup,
  ToggleButton,
  useOnChangeToggleButtonGroup,
} from '.'
import {
  AggregateTarget,
  WbsItemType,
} from '../../../../domain/entity/WbsItemEntity'
import { intl } from '../../../../i18n'
import store, { AllState } from '../../../../store'

type AggregateTargetToggleButtonGroupProps = {
  value: AggregateTarget
  onChange: (_: AggregateTarget) => void
}

export const AggregateTargetToggleButtonGroup = ({
  value,
  onChange: _onChange,
}: AggregateTargetToggleButtonGroupProps) => {
  const [onChange] = useOnChangeToggleButtonGroup(_onChange)
  const deliverableType = useSelector(
    (state: AllState) => state.project.wbsItemTypes.deliverable
  )
  const taskType = useSelector(
    (state: AllState) => state.project.wbsItemTypes.task
  )
  return (
    <ToggleButtonGroup value={value} onChange={onChange}>
      <ToggleButton value={WbsItemType.DELIVERABLE}>
        {
          <img
            src={deliverableType?.iconUrl}
            style={{ verticalAlign: 'middle', marginLeft: '-3px' }}
          />
        }
        {intl.formatMessage({
          id: 'wbsItemType.deliverable',
        })}
      </ToggleButton>
      <ToggleButton value={WbsItemType.TASK}>
        {
          <img
            src={taskType?.iconUrl}
            style={{ verticalAlign: 'middle', marginLeft: '-3px' }}
          />
        }
        {intl.formatMessage({
          id: 'wbsItemType.task',
        })}
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
